/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CreateEstimationModelRequest,
  EstimationModelAffectedEstimationsCountResponse,
  EstimationModelBaseResponse,
  EstimationModelResponse,
  GroupedEstimationModelResponse,
  V1EstimationModelsAffectedEstimationsCountListError,
  V1EstimationModelsArchiveCreateError,
  V1EstimationModelsCreateError,
  V1EstimationModelsDeleteError,
  V1EstimationModelsDetailError,
  V1EstimationModelsGroupedListError,
  V1EstimationModelsListError,
  V1EstimationModelsPublishCreateError,
  V1EstimationModelsReactivateCreateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EstimationModel<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description This endpoint allows authorized users to create a new estimation model, including its items, units, assumption categories, additional fields, resource types, cost types, methodologies, item groups, and currencies. <b>Required permission:</b> CanManageEstimationModels <b>Request body:</b><list type="bullet"><item><description>`RefKey`: (Guid, optional) Identifies the group of models. If empty, a new group is created.</description></item><item><description>`ProjectTypeId`: (Guid, required) The project type for the estimation model.</description></item><item><description>`AdditionalFields`: (List, required) List of additional field definitions.</description></item><item><description>`AssumptionCategories`: (List, required) List of assumption categories.</description></item><item><description>`Items`: (List, required) List of estimation model items.</description></item><item><description>`EstimationModelUnits`: (List, required) List of estimation units (e.g., PD, Hours, StoryPoints, Currency).</description></item><item><description>`ResourceTypes`: (List, required) List of resource types for the model.</description></item><item><description>`CostTypes`: (List, required) List of cost types for the model.</description></item><item><description>`MethodologyIds`: (List, required) List of methodology IDs associated with the model.</description></item><item><description>`ItemGroups`: (List, required) List of item groups for organizing model items.</description></item><item><description>`CurrencyIds`: (List, required) List of currency IDs supported by the model.</description></item></list> <b>Responses:</b><list type="bullet"><item><description>`200 OK`: Returns the created EstiWorld.Api.Models.EstimationModel.EstimationModelResponse object.</description></item><item><description>`400 Bad Request`: Returns EstiWorld.Api.ErrorHandling.ProblemDetailsWithErrorCode if the request is invalid.</description></item><item><description>`404 Not Found`: Returns EstiWorld.Api.ErrorHandling.ProblemDetailsWithErrorCode if a referenced resource does not exist.</description></item></list>
   *
   * @tags EstimationModel
   * @name V1EstimationModelsCreate
   * @summary Creates a new Estimation Model for a specified project type.
   * @request POST:/api/v1/estimation-models
   * @secure
   * @response `200` `EstimationModelResponse` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationModelsCreate = (data: CreateEstimationModelRequest, params: RequestParams = {}) =>
    this.http.request<EstimationModelResponse, V1EstimationModelsCreateError>({
      path: `/api/v1/estimation-models`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationModel
   * @name V1EstimationModelsList
   * @request GET:/api/v1/estimation-models
   * @secure
   * @response `200` `(EstimationModelBaseResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationModelsList = (
    query?: {
      /** @format uuid */
      projectTypeId?: string;
      isPublished?: boolean;
      isLatestPublishedVersion?: boolean;
      includeArchived?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationModelBaseResponse[], V1EstimationModelsListError>({
      path: `/api/v1/estimation-models`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationModel
   * @name V1EstimationModelsDetail
   * @request GET:/api/v1/estimation-models/{estimationModelId}
   * @secure
   * @response `200` `EstimationModelResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationModelsDetail = (estimationModelId: string, params: RequestParams = {}) =>
    this.http.request<EstimationModelResponse, V1EstimationModelsDetailError>({
      path: `/api/v1/estimation-models/${estimationModelId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationModel
   * @name V1EstimationModelsDelete
   * @summary Deletes an estimation model.
   * @request DELETE:/api/v1/estimation-models/{estimationModelId}
   * @secure
   * @response `204` `void` No Content
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationModelsDelete = (estimationModelId: string, params: RequestParams = {}) =>
    this.http.request<void, V1EstimationModelsDeleteError>({
      path: `/api/v1/estimation-models/${estimationModelId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationModel
   * @name V1EstimationModelsGroupedList
   * @request GET:/api/v1/estimation-models/grouped
   * @secure
   * @response `200` `(GroupedEstimationModelResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationModelsGroupedList = (
    query?: {
      /** @format uuid */
      projectTypeId?: string;
      isPublished?: boolean;
      includeArchived?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<GroupedEstimationModelResponse[], V1EstimationModelsGroupedListError>({
      path: `/api/v1/estimation-models/grouped`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationModel
   * @name V1EstimationModelsPublishCreate
   * @request POST:/api/v1/estimation-models/{estimationModelId}/publish
   * @secure
   * @response `200` `EstimationModelResponse` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationModelsPublishCreate = (estimationModelId: string, params: RequestParams = {}) =>
    this.http.request<EstimationModelResponse, V1EstimationModelsPublishCreateError>({
      path: `/api/v1/estimation-models/${estimationModelId}/publish`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationModel
   * @name V1EstimationModelsAffectedEstimationsCountList
   * @summary Existing estimations that reference any version of this model - the impact number the archive confirmation dialog shows (EWM-1036).
   * @request GET:/api/v1/estimation-models/{estimationModelId}/affected-estimations-count
   * @secure
   * @response `200` `EstimationModelAffectedEstimationsCountResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationModelsAffectedEstimationsCountList = (
    estimationModelId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      EstimationModelAffectedEstimationsCountResponse,
      V1EstimationModelsAffectedEstimationsCountListError
    >({
      path: `/api/v1/estimation-models/${estimationModelId}/affected-estimations-count`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description EWM-1036. The model stops being selectable for new estimations while every existing estimation bound to it stays fully functional. Nothing is deleted and the action is reversible via `reactivate`. Applied to every version row of the model's RefKey lineage. <b>Required permission:</b> CanManageEstimationModels (same as Save - an estimator cannot call this even with the model id)
   *
   * @tags EstimationModel
   * @name V1EstimationModelsArchiveCreate
   * @summary Archives (soft-retires) an estimation model.
   * @request POST:/api/v1/estimation-models/{estimationModelId}/archive
   * @secure
   * @response `200` `EstimationModelResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationModelsArchiveCreate = (estimationModelId: string, params: RequestParams = {}) =>
    this.http.request<EstimationModelResponse, V1EstimationModelsArchiveCreateError>({
      path: `/api/v1/estimation-models/${estimationModelId}/archive`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description EWM-1036. The model becomes selectable for new estimations again and the archived-model banner disappears from existing estimations. <b>Required permission:</b> CanManageEstimationModels
   *
   * @tags EstimationModel
   * @name V1EstimationModelsReactivateCreate
   * @summary Reactivates a previously archived estimation model.
   * @request POST:/api/v1/estimation-models/{estimationModelId}/reactivate
   * @secure
   * @response `200` `EstimationModelResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationModelsReactivateCreate = (estimationModelId: string, params: RequestParams = {}) =>
    this.http.request<EstimationModelResponse, V1EstimationModelsReactivateCreateError>({
      path: `/api/v1/estimation-models/${estimationModelId}/reactivate`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });
}
